module.exports = __webpack_public_path__ + "c9e5b45cebe8ba2cfc32b5710c364111.jpg";